import { render, staticRenderFns } from "./ModalRenombrarDocumento.vue?vue&type=template&id=67c392c9&scoped=true&"
import script from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js&"
export * from "./ModalRenombrarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c392c9",
  null
  
)

export default component.exports